// @ts-nocheck
/* eslint-disable */

import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { CardContainer } from 'app/components/shared/card-container';
import { trimTrailingSlash } from 'helpers';
import UsersTable from './UsersTable';
import ViewUser from './view-User';

// v7.1: Users subsystem (read-only) under Cards Management. Users originate from
// the mobile app (signup/FDW) — no add/edit/delete here. List + view; the view
// exposes group-move + eligibility actions (separate APIs) and linked fare media.
const Users: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);

  return (
    <CardContainer>
      <Switch>
        <Route path={`${baseURL}/:id`}>
          <ViewUser />
        </Route>
        <Route exact path={`${baseURL}`}>
          <UsersTable />
        </Route>
      </Switch>
    </CardContainer>
  );
};

export { Users };
